import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';


const GET_IMPORT_LOT_BY_ID = '/import-lot/get-by-id/';
const GET_ALL_SEARCH = '/moha-report/filter';
const CREATE_IMPORT_LOT = '/import-lot/create';
const GET_RESULT_FILE = '/import-lot/get-result-file/'

@Injectable({
  providedIn: 'root'
})
export class EmplomentContractService {

  constructor(private apiService: ApiService) { }


  getImportLotById(id) {
    return this.apiService.get(GET_IMPORT_LOT_BY_ID + id)
        .pipe(map(res => {
            return res
        }));
}

getAllSearch(params: any) {
  return this.apiService.get(GET_ALL_SEARCH, params).pipe(
    map((res: any) => res)
  );
}

createContractLot(body) {
    return this.apiService.post(CREATE_IMPORT_LOT, body)
        .pipe(map(res => {
            return res
        }));
}

getResultFile(id: string) {
    return this.apiService.getFilePostMethod(`${GET_RESULT_FILE}${id}`, null)
        .pipe(map(res => {
            return res;
        }))
}

importFromExcel(listFile: any, type: any) {
  const formdata = new FormData();
  formdata.append('file', listFile[0]);
  formdata.append('type', type);
  return this.apiService.postUpload2(CREATE_IMPORT_LOT, formdata)
    .pipe(map(res => {
      return res;
    }));
}
}
